import * as types from './actionTypes'

export const getSellerHistoriesSuccessAction = (items, replace) => ({
  type: types.GET_SELLER_HISTORIES_SUCCESS,
  payload: { items, replace },
})

export const getTransactionsAction = (itemId, timestampTz) => ({
  type: types.GET_SELLER_HISTORY_DETAIL,
  payload: { itemId, timestampTz },
})

export const getInstalmentHistoriesAction = periodId => ({
  type: types.GET_INSTALMENT_HISTORIES,
  payload: periodId,
})
